import React, { StrictMode } from 'react';
import {  createRoot } from 'react-dom/client';
import App from './containers/App';

createRoot(document.querySelector('.cbdce-education-finder')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);